import { makeStyles } from "@material-ui/styles";


const useStyle = makeStyles({
    datesParent: {
        display: 'grid',
        gridTemplateColumns: 'repeat(7, 1fr)',
        width: '60%',
        margin: '0 auto',
        "@media (max-width: 1500px)": {
            width: '100%',
        }
    },
    autoReserveDayTitle: {
        cursor: 'pointer',
        background: 'rgba(62, 205, 219, 0.3)',
        padding: '0.5rem',
        borderRadius: '4px',
        marginLeft: '0.5rem',
        "@media (max-width: 700px)": {
            fontSize: "12px",
            padding: '0.5rem 0rem',
        },
        "@media (max-width: 450px)": {
            fontSize: "10px",
            padding: '0.5rem 0',
        }
    },
    autoReserveItem: {
        paddingLeft: '0.5rem',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '14px',
        "@media (max-width: 700px)": {
            fontSize: "12px",
        },
        "@media (max-width: 450px)": {
            fontSize: "10px",
        }
    },
    autoReserveParent: {
        display: 'grid',
        gridTemplateColumns: 'repeat(7, 1fr)',
        width: '60%',
        margin: '0 auto',
        fontSize: '16px',
        textAlign: 'center',
        "@media (max-width: 1500px)": {
            width: '100%',
        }
    },
    date: {
        marginTop: '1rem',
        borderRadius: '10px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
        width: '107px',
        height: '88px',
        "@media (max-width: 850px)": {
            width: '90px',
            height: '80px',
        },
        "@media (max-width: 700px)": {
            width: '50px',
            height: '50px',
        },
        "@media (max-width: 450px)": {
            width: '40px',
            height: '40px',
        }
    },
    dayText: {
        textAlign: 'center',
        "@media (max-width: 700px)": {
            fontSize: '13px'
        },
        "@media (max-width: 450px)": {
            fontSize: '10px'
        }
    },
    monthText: {
        fontSize: '14px',
        "@media (max-width: 700px)": {
            fontSize: '11px'
        },
        "@media (max-width: 450px)": {
            fontSize: '10px'
        }
    },
    reservedCounter: {
        position: 'absolute',
        top: '-0.5rem',
        left: '-0.5rem',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '30px',
        height: '30px',
        borderRadius: '50%',
        color: '#fff',
        background: '#3ecddb',
        "@media (max-width: 700px)": {
            width: '15px',
            height: '15px',
            fontSize: '12px'
        },
        "@media (max-width: 450px)": {
            width: '12px',
            height: '12px',
            fontSize: '10px'
        }
    },
    reservedCounterScenario: {
        position: 'absolute',
        top: '-0.5rem',
        left: '-0.5rem',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '30px',
        height: '30px',
        borderRadius: '50%',
        color: '#fff',
        background: '#4ade80',
        "@media (max-width: 700px)": {
            width: '15px',
            height: '15px',
            fontSize: '12px'
        }
    },
    patientName: {
        fontWeight: 'bold',
        fontSize: '17px',
        "@media (max-width: 800px)": {
            fontSize: '14px'
        },
        "@media (max-width: 600px)": {
            fontSize: '12px'
        }
    },
    mobileNumberParent: {
        marginRight: '3rem',
        flexDirection: 'column',
        justifyContent: 'center',
        "@media (max-width: 800px)": {
            marginRight: '1rem',
            fontSize: '14px'
        },
        "@media (max-width: 650px)": {
            display: 'none'
        }
    },
    patientInfoParent: {
        flexDirection: 'column',
        marginRight: '1rem',
        width: '300px',
        "@media (max-width: 800px)": {
            width: '200px',
        },
        "@media (max-width: 600px)": {
            width: '150px',
        },
        "@media (max-width: 400px)": {
            width: 'auto',
        }
    },
    transactionParent: {
        cursor: 'pointer',
        background: 'rgba(62, 205, 219, 0.1)',
        border: '1px solid rgb(62, 205, 219)',
        padding: '0.5rem 1rem',
        borderRadius: '8px',
        fontSize: '16px',
        color: 'rgb(62, 205, 219)',
        fontWeight: 'bold',
        "@media (max-width: 800px)": {
            fontSize: '14px',
            padding: '0.5rem',
        },
        "@media (max-width: 600px)": {
            fontSize: '12px',
            padding: '0.3rem',
        }
    },
    patientListParent: {
        width: '100%',
        marginBottom: '1.5rem',
        padding: '0 2rem',
        "@media (max-width: 600px)": {
            padding: '0 1rem',
        }
    },
    mobileGroupName:{
        display:'none',
        "@media (max-width: 600px)": {
            color: '#c2c2c2',
            fontSize: '11px',
            display:'block'
        }
    },
    nationalCode:{
        color: '#c2c2c2',
        fontSize: '12px',
        "@media (max-width: 600px)": {
            display:'none'
        }
    },
    patientFullInfoParent:{
        paddingTop: '1rem',
        "@media (max-width: 600px)": {
            fontSize:'14px'
        }
    }
});

export default useStyle;
